





















































































































































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import * as helper from '@/assets/_js/helpers'
import SimpleTile from '@/components/common/SimpleTile.vue'
import PackageCard from '@/components/packages/PackageCard.vue'
import JsonFetchAlert from '@/components/common/JsonFetchAlert.vue'
import TileMap from '@/components/common/TileMap.vue'
import { Accountext, Package } from 'dapp-client'
import AccountsTable from '@/components/accounts/AccountsTable.vue'
import marked from 'marked'
const numeral = require('numeral')

@Component({
  components: {
    SimpleTile,
    PackageCard,
    JsonFetchAlert,
    TileMap,
    AccountsTable
  }
})
export default class PkgDetails extends Vue {
  // data
  @Prop() private id!: any
  private numeral = numeral
  private pkgJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }
  private dspJson: any = {
    error: true,
    errorMsg: '',
    data: {}
  }

  // computed
  get pkgDetails() {
    return vxm.dappservices.packageTable.find(
      (pkg: Package) => pkg.id === parseInt(this.id)
    )
  }

  get location() {
    if (!this.pkgJson.error) {
      return {
        lat: this.pkgJson.data.locations[0].latitude,
        long: this.pkgJson.data.locations[0].longitude
      }
    } else return { lat: 0, long: 0 }
  }

  get pkgUsers() {
    return vxm.dappservices.accountTable.filter(
      (user: Accountext) =>
        user.provider === this.pkgDetails!.provider &&
        user.pending_package === this.pkgDetails!.package_id &&
        user.service === this.pkgDetails!.service
    )
  }

  // method
  selectPackage(pkg2select: any) {
    vxm.packages.selectPackage(pkg2select)
  }

  async loadData() {
    if (this.pkgDetails) {
      let pkgJson = await vxm.jsondb.getPkgJson(this.pkgDetails)
      let dspJson = await vxm.jsondb.getDspJson(this.pkgDetails)
      this.pkgJson = pkgJson
      this.dspJson = dspJson
    }
  }

  compileMarkdown(markdown: any) {
    return marked(markdown, { sanitize: true })
  }

  @Watch('pkgDetails')
  async onPkgChange(val: any, oldVal: any) {
    await this.loadData()
  }

  // Lifecycle hooks
  created() {}
  async mounted() {
    await this.loadData()
  }
  updated() {}
  destroyed() {}
}
